var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.787 23.123a.69.69 0 00.997 0 .707.707 0 000-.997L2.42.781a.71.71 0 00-1.006 0 .724.724 0 000 .997l21.373 21.345zM5.547 2.353L8.53 5.345h11.258V5.19c0-1.884-.96-2.835-2.863-2.835H5.548zm-.75 4.354L1.35 3.25C.929 3.689.71 4.33.71 5.189v9.255c0 1.884.95 2.835 2.871 2.835h.494V9.286c0-1.088.247-1.957.723-2.579zm4.976-.119L23.783 20.6c.412-.439.623-1.08.623-1.92V9.422c0-1.884-.96-2.835-2.863-2.835H9.773zm9.84 14.926L5.776 7.667c-.292.44-.448 1.025-.448 1.756v9.255c0 1.884.951 2.835 2.872 2.835h11.413z"
  })));
}

export default __webpack_public_path__ + "static/media/transparent.83824a0d.svg";
export { SvgTransparent as ReactComponent };